export const fps = 30;
export const events = {
    compositionUpdate: 'sermon-recap-composition-update',
    sideBarPopUpOpen: 'sermon-recap-popup-sidebar-open',
    sideBarPopUpClose: 'sermon-recap-popup-sidebar-close'
};
// position y is inverted to match the cartesian plane
export function translate({ x, y }) {
    return `translate(${x || 0}px, ${-(y || 0)}px)`;
}
export function filter(filter) {
    return Object.entries(filter).reduce((string, [key, value]) => string + `${key}(${value}) `, '');
}
